import React from 'react';
import 'assets/styles/switch.scss';

const Switch = ({ value, onChange }) => {
  const getWrapperClass = () => {
    let result = 'switch';

    if(!value) {
      result = `${result} reverse`;
    }

    return result;
  }

  return <div onClick={() => onChange(!value)} className={getWrapperClass()}>
    <div className="text">
      {value ? 'ON' : 'OFF'}
    </div>
    <div className="dot" />
  </div>
}

export default Switch;